<template>
  <div class="main-page">
    <h3>杭州火脸软件合作协议</h3>
    <p>甲方：杭州火脸科技有限公司</p>
    <p>乙方：入驻申请服务商</p>
    <p>甲乙双方本着互惠互利、共同发展的原则，经友好协商，依照《中华人民共和国合同法》等有关法律法规的规定,就合作杭州火脸软件事宜，达成如下协议：
    </p>
    <h5>一、定义</h5>
    <p>1.1 杭州火脸软件系统，简称“火脸”，该软件系统对接支付平台和商户，是能够实现移动线下聚合支付、收银管理和在线营销推广等多功能的移动支付大数据营销软件。</p>
    <p>1.2 支付平台：包括第三方支付机构等具有相应收付金融支付资质的有关主体。</p>
    <p>1.3 支付服务费率：指支付平台制定并收取的有关支付的服务费与支付金额的比率。</p>
    <p>1.4 商户：经乙方推荐成功开户并使用杭州火脸软件系统的商户。</p>
    <h5>二、双方合作内容</h5>
    <p>2.1 甲乙双方就推广使用甲方所有的杭州火脸软件系统展开合作，乙方作为甲方的服务商，以本协议约定的方式推广商户使用杭州火脸软件系统，并为推广的商户提供相应服务。</p>
    <p>2.2 为顺利推广使用甲方所有的杭州火脸软件系统，甲方许可乙方使用“火脸”软件（著作权登记号： 2022SR0523119  ），许可方式为非独占许可，许可的权利范围为非专有使用权即一般合法使用或甲乙双方约定的使用用途，许可使用期限和地域范围具体见本协议第2.3款约定。</p>
    <h5>三、合作规则</h5>
    <p>3.1 在合作区域内，乙方推荐商户给甲方，甲方为乙方在杭州火脸软件系统后台（后台地址：https://8.lianok.com/）开设相应的账号，以方便商户使用软件服务。</p>
    <p>3.2 在合作区域为【全国区域或省级区域】的前提下，乙方申请并经甲方审核同意，可在合作区域内以招商、合作等任何形式发展一级服务商，但不允许发展二级服务商，若乙方违反该约定的，按照违约条款处理。</p>
    <p>3.3 如乙方取得发展一级软件合作商或服务商权限，可按本协议第2.3款约定，在本合同有效期内将软件著作权许可一级软件合作商或服务商使用，许可使用费由乙方自行收取，但需向甲方报备、申请开户。乙方发展的软件合作商或服务商由乙方自行维护与服务，相关权利义务及责任由乙方自行承担。除此外乙方不得将软件著作权的非专有使用权转让给第三方或授予第三方代理、销售或寻求第三方合作，或以任何方式向第三方透露与该软件相关的技术细节，或擅自对软件进行修改。同时，乙方不得自行或授权任何第三方对软件产品进行合同约定内容之外的开发、利用。</p>
    <p>3.4 为了便于乙方开展有关业务，甲方为乙方提供开展业务所需培训（线上），乙方应熟悉业务规则和流程，积极有效宣传和服务商户。</p>
    <p>3.5 双方同意并确认合作业务将受支付平台的政策和交易规则的修改而调整，甲方会以平台（https://8.lianok.com/）、短信、电话通知、微信等形式及时发布有关的新政策和信息，乙方应及时调整业务内容，且应当在收到上述信息后及时向商户解释有关事项。</p>
    <p>3.6 在合作期限内，乙方可向甲方采购或自行购买有关硬件设备和设施。</p>
    <p>3.7 本协议签署当日起甲方按照服务规则抽取乙方每月的佣金作为服务费。</p>
    <p>3.8 在乙方不存在违反本协议以及甲方制定的产品或服务使用规则的情况下，甲方将按照合同约定结算费率给予乙方一定的支付服务费率作为奖励。乙方同意支付服务费奖励将因我司运营策略的结算费率的调整而相应调整，以下为我司费率表。</p>
    <p>3.9 合作期限内，甲乙双方将按月结算支付服务费奖励，即甲方于次月28日（节假日顺延）通过本协议载明的电子邮件或运营平台就上一月的奖励金额与乙方进行对账，乙方在收到甲方发送的数据后，向甲方开具合法有效等额的增值税专用发票，甲方在收到相应发票后的七个工作日内支付至乙方所持有的指定结算账户：</p>
    <p>因乙方未开具发票或未开具合格发票或未提供明确的银行账户信息，导致付款延后的，由乙方自行承担因迟延付款产生的经济损失和法律责任。</p>
    <p>3.10 本协议未约定的合作规则和业务规则，以甲方制定及发布在运营平台的各项制度以及本协议附件《火脸服务商管理办法》（见附件一）内容为准。乙方应严格遵守甲方发布的收费标准和服务方案、产品内容和支付平台的有关政策和规则。</p>
    <p>3.11 乙方同意并将促使其下级服务商和商户在首次注册和使用杭州火脸软件平台及其他软件产品时，都须同意《杭州火脸软件平台使用协议》并在后续使用中严格遵守执行。此线上协议一旦签订即有效且自动成为本协议的一部分，与本协议具有同等效力。</p>
    <h5>四、甲方的权利和义务</h5>
    <p>4.1 在确定乙方按约定支付软件许可使用费后，甲方为乙方开通登陆系统权限，即为完成授权使用的义务。</p>
    <p>4.2 甲方有权监督乙方的业务开展各项行为，如发现乙方违规的，有权要求乙方更正，情节严重的，甲方有权解除合同。</p>
    <p>4.3 甲方负责持续完善开发平台，涉及软件更新的，乙方应及时配合。</p>
    <p>4.4 甲方负责审核乙方发展一级软件合作商或服务商权限。</p>
    <p>4.5 甲方负责软件的日常维护，并在线提供必要的咨询和技术支持。</p>
    <p>4.6 甲方有权根据业务发展需要，制定新的业务规则和考核办法，并定期发布在系统平台。</p>
    <p>4.7 因乙方违反本协议的约定和业务规则，经甲方要求乙方更正，乙方三日内不予处理或处理不当的，甲方有权暂停或部分暂停乙方的系统平台操作权限，乙方仍不予以更正的，甲方有权随时单方解除本协议，并取消支付服务费率奖励政策。</p>
    <p>4.8 甲方有权因甲方风控管理或其他需要要求乙方提供相应配合，包括但不限于实地考察商户门店、提供包含商户信息的照片或视频等。</p>
    <h5>五、乙方的权利和义务</h5>
    <p> 5.1 乙方应熟悉业务规则和流程，在合作区域内积极有效宣传、推广甲方产品，并服务商户，不得推广其他同类型产品。</p>
    <p>5.2 乙方应为合法的市场主体，应当合规经营，具备足够的硬件和软件实力。乙方应自行办理相关的营业和经营许可证照，并于办理后三个工作日内按照甲方要求书面报备给甲方。乙方同意并保证该经营主体作为本协议共同的乙方一并履行本协议。</p>
    <p>5.3 乙方应做好下级服务商和商户管理工作，严格审查资质，不得默认、引导、协助下级服务商或商户进行刷单、套现、虚假交易等任何形式的违法违规（包括违反支付平台制定的规则）的行为，发现有以上行为时乙方应立即关闭相关账号，主动进行整改并向甲方进行报备。</p>
    <p>5.4 乙方在业务开展过程中，未经甲方书面授权，不得使用甲方的特有的商号、商标、标识，不得违规使用支付平台的商标、标识等。</p>
    <p>5.5 乙方应对下级服务商和商户尽全面审核、管理责任，对其行为承担连带责任。乙方应在其与下级服务商或商户签署的服务协议中列明甲方产品及服务的使用条件和规则，如因乙方下级服务商或商户不当适用甲方产品及服务并引发甲方损失或赔偿的，甲方有权向乙方进行追偿。 </p>
    <p>5.6 乙方应提供优质服务，维护甲方和甲方产品的良好信誉，如因乙方或其下级服务商过错造成商户损失的，由乙方与其下级服务商自行承担赔偿责任，因此引起甲方损失的，依法向甲方承担损失赔偿责任。</p>
    <p> 5.7 乙方以“杭州火脸”协作推广商的名义，向商户推介使用杭州火脸软件平台，在推介行为中，不得使用甲方代理人的字眼或实施上述法律含义的行为，乙方作为独立的法律主体承担有关法律责任。</p>
    <p>5.8 乙方应该严格遵守甲方制定的各项业务规则和考核办法。</p>
    <p>5.9 乙方应按约定支付软件许可使用费，并于登录运营平台权限开通后当日向甲方回函确认。</p>
    <p>5.10 乙方应如实报送商户信息，保证商户信息真实性。如部分商户因支付平台审核不通过，乙方应及时与商户做好协调工作。</p>
    <p>5.11 乙方应尊重并确保不侵犯甲方对本合同项下软件产品依法享有（保护或行使）的知识产权，否则，乙方应就其侵权行为对甲方承担损失赔偿责任。
</p>
    <p>5.12 在合作期限届满后，乙方对于接触到的甲方有关软件的所有信息（包括但不限于乙方接触到的甲方产品、客户、市场等方面的技术和商业资料，以及已经过甲方确认（包括未实施）的所有与本合同有关的文字和图片资料等）承担保密义务。</p>
    <h5>六、免责条款</h5>
    <p>6.1 任何一方由于不可抗力（在本协议签署后发生的、本协议签署时不能预见的、其发生与后果是无法避免或克服的、妨害任何一方全部或部分履约的所有事件，包括但不限于地震、台风、水灾、战争、国际或国内运输中断、流行病、罢工等）而导致不能全部或部分履行本协议项下的义务，发生如下后果：</p>
    <p>（1）如果发生不可抗力事件，影响一方履行其在本协议项下的义务，则在不可抗力造成的延误期内中止履行，不视为违约；</p>
    <p>（2）发生不可抗力的一方应及时书面通知另一方，并在其后30个工作日内提供不可抗力发生及其持续事件的证明；</p>
    <p>（3）如发生不可抗力事件，双方应友好协商，以找到公平的解决办法，并应尽一切合理努力将不可抗力的影响减少到最低限度；</p>
    <p>（4）迟延履行期间发生的不可抗力不具有免责效力。</p>
    <p>6.2 因系统更新、维护、检测、黑客攻击、电信运营部门的技术调整或故障导致暂时中断服务，或支付平台停止服务或系统崩溃等非因甲方原因导致的服务中断情况，不视为甲方违约。</p>
    <h5>七、保密</h5>
    <p>7.1 未经对方书面同意，任何一方均不得向其他第三方泄漏在协议履行过程中能够知悉的商业秘密或相关信息（包括但不限于协议本身、政策信息、账号信息、交易数据等），也不得将本协议内容及相关档案材料泄漏给任何第三方。如果任意一方违反本条款约定的，应赔偿守约方因此遭受的损失。但法律、法规规定必须披露的除外。</p>
    <p>7.2 保密义务不因本协议到期、解除、失效而终止，乙方应在协议终止后继续履行上述义务。</p>
    <h5>八、违约和解除</h5>
    <p>8.1 乙方违反本协议（含附件和有关合作规则）约定，给甲方造成损失的，或乙方发展的下级服务商及其拓展的商户给甲方造成损失的，乙方应就该等行为给甲方造成的损失向甲方承担赔偿责任。</p>
    <p>8.2 如因乙方或乙方发展的下级服务商及商户涉及严重违法违规行为（如诈骗、赌博等），甲方有权暂停或取消相关平台账号使用权限并不予发放支付服务费奖励，并就该等服务商或商户行为给甲方造成的损失向乙方或乙方发展的下级服务商进行追偿。</p>
    <p>8.3 如存在本协议第8.1款、第8.2款情形，甲方要求乙方予以更正或消除不良影响后的三日内，乙方未予以更正或更正不符合要求的，甲方有权解除本协议，取消奖励政策，并按照前述条款约定向乙方主张赔偿责任。</p>
    <p>8.4 本协议项下所称损失包括但不限于守约方实现债权的费用（包括但不限于律师费、诉讼费、保全费、差旅费、调查费、公证费等）。</p>
    <p>8.5 本协议解除后乙方应配合甲方移交有关协议后续事项和商户资料信息等。</p>
    <h5>九、附则</h5>
    <p>9.1 本协议经双方签字盖章生效后，任何更改均需双方协商一致并以书面形式确认。</p>
    <p>9.2 乙方签订本协议前已经充分认知本协议（包含附件）的内容以及法律效力和后果，并完全理解和接受。本协议替代此前双方就协议所涉内容签订的所有口头或书面协议。</p>
    <p>9.3 本协议壹式贰份，双方各执壹份，具有同等法律效力。</p>
    <p>9.4 本协议附件与本协议具有同等法律效力。</p>
    <p>9.5 甲乙双方因履行本协议而发生争议的，双方应协商解决，协商不成的，任何一方均有权向甲方所在地人民法院起诉。</p>
    <h5>十、汇款账号</h5>
    <p>本协议所涉应当支付给甲方的费用，乙方应当支付到甲方如下对公账户：</p>
    <p>开户名称：杭州火脸科技有限公司</p>
    <p>开户行：杭州银行蒋村</p>
    <p>支行账号： 3301040160011328518</p>
    <p>（以下无正文，为《杭州火脸软件合作协议》的签字签章部分）</p>
    <h5>附件一：《火脸服务商管理办法》 </h5>
    <h5>一、目的</h5>
    <p>为规范乙方义务推广行为，规范有关业务服务活动，甲方特制定本《火脸服务商管理办法》。本办法作为双方签署的《杭州火脸软件合作协议》或其他名称的补充协议（以具体签约的协议名称为准，以下简称“主协议”）的附件。</p>
    <h5>二、管理内容</h5>
    <p>乙方在与甲方合作期间不得出现以下行为：</p>
    <h5>(一)弄虚作假</h5>
    <p>1、伪造、篡改与甲方合作相关的材料或信息；</p>
    <p>2、通过各种方式骗取甲方的服务费或甲方的各类奖励费用或资源，给甲方或商户造成严重损失（包括但不限于经济损失、名誉损失等，下同）；
</p>
    <p>3、通过各种方式，推介虚假商户、无效商户与甲方合作，或制造虚假订单，给甲方或商户造成严重损失；</p>
    <p>4、引导、明知、协助商户提供或拟提供伪造、虚假的资料（如：相关证明、印章、签名、营业执照、网站交易记录等）；</p>
    <p>5、通过各种方式，利用甲方产品从事或协助商户套现，如主导、教唆、参与、默许、协助商户进行套现、刷单、虚假交易等且造成严重后果的行为；</p>
    <p>6、其他造成甲方或商户严重损失的违反法律法规规定或主协议约定的其他行为；</p>
    <p>7、在商户接入时，未实地核实商户线下店铺，未恪守诚实告知原则，隐瞒商户实际经营情况。</p>
    <h5>(二)擅自以甲方或其合作第三方支付公司的名义作业</h5>
    <p>1、以甲方或合作第三方支付公司的名义招商、发展代理、收取商户费用以及利用甲方及其合作第三方支付公司的资源谋取不正常利益。</p>
    <p>2、未经甲方书面授权，不得将甲方产品推广服务再次委托给其他第三方，包括通过招收二级代理、委托第三方进行类似的商业活动等方式进行，并严禁向其他第三方收取任何形式的代理费。</p>
    <h5>(三)违反保密协议</h5>
    <p>1、盗取、披露、买卖、赠送或超越授权范围使用甲方、甲方商户或其他服务商及其客户的数据资料信息（包括乙方主动向第三方透露或因推广服务过失将信息泄露给第三方或被第三方盗用等）；</p>
    <p>2、其他违反法定或主协议约定保密义务的行为。</p>
    <h5>(四)恶意同行竞争</h5>
    <p>1、私下与甲方具有同类竞争业务的第三方公司展开类似合作；</p>
    <p>2、公开渠道发布甲方及其合作第三方支付公司负面言论或谣言（特别是各媒体渠道），损害甲方及其合作第三方支付公司名誉；</p>
    <p>3、合作商之间为了争夺资源和客户，诬蔑同行，恶意举报同行；</p>
    <p>4、恶意扰乱同行的正常业务秩序；</p>
    <p>5、明知是已对接甲方业务的商户，仍进行开拓，恶意损害同行利益；</p>
    <p>6、贿赂甲方工作人员或贿赂商户（包括金钱、礼品等）；</p>
    <p>7、为招聘新员工，劝诱、煽动、欺骗、协助甲方员工离职；</p>
    <p>8、聘用甲方已离职员工；</p>
    <p>9、其他涉及恶意同行竞争的行为。</p>
    <h5>(五)管理不善</h5>
    <p>1、未经商户许可擅自索要、使用商户在甲方产品的账户或移动支付相关的账户名或密码的行为；</p>
    <p>2、其服务的商户通过各种方式骗取甲方各类营销或奖励费用；</p>
    <p>3、明知或应当知道商户不符合规定的准入资格，或从事法律法规所限制（且无经营许可证）、禁止的业务，或存在高危、风险，仍向其推介甲方产品；
</p>
    <p>4、以各种手段规避甲方及其合作第三方支付公司各项行为准则和管理制度（如：假冒商户身份撤销投诉）；</p>
    <p>5、其他管理不善造成甲方实际损失或对甲方产生不良影响的行为。</p>
    <h5>(六)服务品质差</h5>
    <p>1、强制要求商户缴纳服务费；</p>
    <p>2、恶意骚扰、辱骂、恐吓、嘲笑商户，造成商户严重不满；</p>
    <p>3、超出甲方宣传资料范围，夸大甲方软件产品或服务内容或者保证使用效果的行为；</p>
    <p>4、其他服务品质严重不符合要求造成甲方实际损失或对甲方产生不良影响的行为。</p>
    <h5>(七)其他禁止性行为</h5>
    <p>1、从事违反国家法律法规的行为；</p>
    <p>2、恶意损坏甲方品牌和形象，给其带来负面影响；</p>
    <p>3、为甲方的竞争对手提供产品营销或类似服务；</p>
    <p>4、未经甲方同意，擅自以甲方名义召开任何形式招商会，产品推荐会等形式会议；</p>
    <p>5、被商户投诉服务商人员态度差；</p>
    <p>6、承诺商户提供甲方产品相关服务但未及时提供或兑现；</p>
    <p>7、未与商户确认合作第三方支付公司账户、公司基本信息，影响商户业务正常进行；</p>
    <p>8、回答商户问题含糊其辞，引起商户误解，如商户咨询的问题及答案是明确的，但服务商不予清楚解答；</p>
    <p>9、在推广活动中传递错误营销规则，给商户、甲方造成损失；</p>
    <p>10、未经甲方审核，私自对外发布与甲方及其合作第三方支付公司相关的宣传内容；</p>
    <p>11、擅自更改全国统一的甲方物料内容（除服务商公司地址，电话等信息）；</p>
    <p>12、未按甲方给出的模板制作产品推广资料或产品解决方案。</p>
    <p>13、合作过程中辱骂、诋毁我司工作人员。</p>
    <h5>三、违规认定、处罚和制度修改 </h5>
    <p>1、违规行为由甲方依据实际情况判断确定。</p>
    <p>2、在主协议履行期间，如乙方或其发展的下级服务商及商户出现上述情况之一的，甲方有权要求乙方予以整改。乙方在收到甲方通知后拒绝整改或经整改仍未到位的，视为乙方违约，甲方有权立即单方提前解除主协议或暂停、取消乙方的服务商资格，并取消所有支付服务费奖励，如造成甲方损失的，乙方还应承担赔偿责任。甲方提前解除主协议的，自甲方发出解除通知之日解除。</p>
    <p>3、如乙方或乙方下级服务商策划、强迫、唆使、煽动、诱骗甲方平台商户变更使用其他品牌支付通道或者乙方以任何形式骗取甲方扶持资源的，乙方需返还双方合作中所有形式的支付服务费奖励及活动政策中对应部分的补贴，包括但不限于资金奖励、硬件产品使用费用优惠等。同时一旦出现上述情况，乙方需按与甲方合作第一年收费标准补齐后续每年的续约费用。</p>
    <p>4、如乙方或乙方发展的下级服务商开拓已对接过甲方产品的商户，此部分商户的支付服务费奖励及其他相关收益，仍归属于与商户最初合作的服务商所有。且由于乙方及乙方发展的下级服务商行为造成甲方或第三方损失的，由乙方承担相应赔偿责任。</p>
    <p>5、根据商户交易情况及风险控制需要，甲方有权根据最新的市场或政策情况修改本办法，经修改的制度将以电子邮件、乙方网站公告或其他书面方式通知。</p>
    <p>6、本办法或经修改后的办法自甲方以任何形式公告之日起生效。</p>
  </div>
</template>

<script>
  export default {
    name: 'agentJoinProtocol',
    data() {
      return {

      }
    },
    created () {
      document.title = '服务商入驻协议'
    }
  }
</script>

<style>
.main-page {
  padding: 24px;
}
  p {
    text-align: left;
  }
  h5 {
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/AgentJoinProtocol.vue